export const colors = {
  white: '#FFFFFF',
  mainColor: '#111111',
  accentColor: '#FF2DAB',
  bodyTextColor: '#333333',
  imageBackground: '#F6F8FB',
  transparent: 'transparent',
  secondaryTextColor: '#666666',
};

export const theme = {colors};
